import template from "./template.json";

// TODO: Offload this work to a lambda...
export default function createHtmlPage(
  pageContent,
  companyName,
  companyDescription,
  companyPhone,
  myGoogleTag,
) {
  const parser = new DOMParser();
  // TODO: Add favicon.ico functionality
  const styleVersion = 1;
  const googleTag = myGoogleTag ?? ""; //"G-PQ5T9E73QM";// Example easyzilla google tag
  const googleTagManagerScript = "<!-- Google tag (gtag.js) -->" +
    `<script async src=https://www.googletagmanager.com/gtag/js?id=${googleTag}></script>` +
    "<script>" +
    "window.dataLayer = window.dataLayer || [];" +
      "function gtag(){dataLayer.push(arguments);}" +
      "gtag('js', new Date());" +
      `gtag('config', '${googleTag}');` +
    "</script>";
  const easyzillaScripts = "<script src='https://secure.easyzilla.com/easyzilla-scripts.js'></script>";
  // TODO: Make sure to deploy latest style publicly for this to work
  const templateString = `<head>${template.metaData}${template.fontImport}<link rel='stylesheet' href='https://secure.easyzilla.com/styles/v${styleVersion}.css'>${googleTag && googleTagManagerScript}${easyzillaScripts}</head><body class='webpageRoot'>${pageContent}</body>`;
  const parsedTemplate = parser.parseFromString(templateString, "text/html");
  // Add language attribute to html tag
  parsedTemplate.documentElement.setAttribute("lang", "en");
  // Update metadata
  parsedTemplate.title = companyName;
  parsedTemplate.getElementsByTagName("meta").author.content = companyName;
  // Include company phone in description if available
  const enhancedDescription = companyPhone ? `${companyDescription}. Contact at ${companyPhone}` : companyDescription;
  parsedTemplate.getElementsByTagName("meta").description.content = enhancedDescription;
  
  try {
    // Update button click event to be native html friendly if element is available
    parsedTemplate.getElementById("topHeaderMenuMobileButton").setAttribute("onclick", "toggleMobileMenu()");
  } catch (e) {
    console.error("Error setting onclick for topHeaderMenuMobileButton", e);
  }
  try {
    [...parsedTemplate.getElementById("mobileMenu").getElementsByTagName("a")].forEach((tag) => tag.setAttribute("onclick", "toggleMobileMenu()"));
  } catch (e) {
    console.error("Error setting onclick for mobileMenu items", e);
  }
  return `<!DOCTYPE html>${parsedTemplate.documentElement.outerHTML}`;
}
